/**
 * Filkhedma API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface VisitDoneService { 
    /**
     * Service ID
     */
    serviceId?: string;
    /**
     * Service Type
     */
    type?: VisitDoneService.TypeEnum;
    /**
     * Service English Name
     */
    nameEn?: string;
    /**
     * Service Arabic Name
     */
    nameAr?: string;
    /**
     * Service Done Quantity
     */
    qty?: number;
    /**
     * Service Required Quantity In This Visit
     */
    requiredQty?: number;
    /**
     * Service price
     */
    price?: number;
    /**
     * Service estimated time
     */
    estimatedTime?: string;
}
export namespace VisitDoneService {
    export type TypeEnum = 'guarantee';
    export const TypeEnum = {
        Guarantee: 'guarantee' as TypeEnum
    };
}
